import { createContext } from 'react'
import { Language } from '@/utils/language'
import { Currency } from '@/utils/currency'
import { PlansRes } from '@/types/api'

export const GlobalContext = createContext<{
  lang: Language
  currency: Currency
  showMemberModalFromSSR: boolean
  memberModalClosableFromSSR: boolean
  isIntercomLoad: boolean
}>({
  lang: Language.enUS,
  currency: Currency.US,
  showMemberModalFromSSR: false,
  memberModalClosableFromSSR: true,
  isIntercomLoad: false
})

export type PlanTypeEnum = 'basic' | 'pro' | 'enterprise' | 'custom'

export type PlanTimeEnum = 'annually' | 'monthly'

export const LayoutContext = createContext<{
  showMemberModal: boolean
  onShowMemberModal: ({
    planType,
    planTime,
    showPayment,
    errorMsg,
    isRenewal,
    subAccountCount,
    originResData
  }: {
    planType?: PlanTypeEnum
    planTime?: PlanTimeEnum
    showPayment?: boolean
    errorMsg?: string
    isRenewal?: boolean
    subAccountCount?: number
    originResData?: PlansRes
  }) => void
  renderMemberModal: () => JSX.Element | null
  renderMaskMember: () => JSX.Element | null
  onHideMemberModal: () => void
  planTime: 'annually' | 'monthly'
  planType: PlanTypeEnum
  showPaymentModal: boolean
  paymentType: 'payment' | 'withdrawal' | 'trial' | 'share'
  onShowPaymentModal: ({ type }: { type?: 'payment' | 'withdrawal' | 'trial' | 'share' }) => void
  onHidePaymentModal: () => void
  subAccountCount: number
  originResData?: PlansRes
}>({
  showMemberModal: false,
  onShowMemberModal: () => {
    //
  },
  renderMemberModal: () => null,
  renderMaskMember: () => null,
  onHideMemberModal: () => {
    //
  },
  planTime: 'annually',
  planType: 'pro',
  showPaymentModal: false,
  paymentType: 'payment',
  subAccountCount: 0,
  originResData: {} as PlansRes,
  onShowPaymentModal: () => {
    //
  },
  onHidePaymentModal: () => {
    //
  }
})

export const MobileLayoutContext = createContext<{
  showMobileMemberModal: boolean
  onShowMobileMemberModal: ({
    planType,
    planTime
  }: {
    planType?: PlanTypeEnum
    planTime?: 'annually' | 'monthly'
  }) => void
}>({
  showMobileMemberModal: false,
  onShowMobileMemberModal: ({ planType = 'basic', planTime = 'annually' }) => {
    //
  }
})
